<template>
  <svg
    :x="x"
    :y="y"
    :width="width"
    :height="height"
    preserveAspectRatio="none"
    :viewBox="viewBox"
  >
    <path fill="white" stroke="none" :d="isPrintMode ? path : undefined">
      <animate
        v-if="!isPrintMode"
        attributeName="d"
        :from="previousPath"
        :to="path"
        dur="0.8s"
        repeatCount="1"
        fill="freeze"
        calcMode="spline"
        keyTimes="0;1"
        keySplines="0.42 0 0.58 1"
      />
    </path>
  </svg>
</template>
<script>
import { normalizeArray, fadeInOut } from '../../util/svgUtils.js'
import visualizeAsPath from '../../util/visualizeAsPath'
import { store } from '../../store/store'

import { cutSilence, normalDistribute } from '../../util/autoEnhance'
export default {
  name: 'ClassicViz',
  props: {
    soundData: {
      type: Object,
      required: true,
    },
    x: {
      type: Number,
      required: true,
    },
    y: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    visualOptions: {
      type: Object,
      required: false,
    },
  },
  data: function () {
    const widthVisual = 700
    const heightVisual = 250
    return {
      widthVisual,
      heightVisual,
      topBorder: 0,
      // needed for the animation
      previousPath: visualizeAsPath([], widthVisual, heightVisual),
    }
  },
  computed: {
    viewBox: function () {
      return [0, 0, this.widthVisual, this.heightVisual].join(' ')
    },
    path: function () {
      let inputArray = this.soundData.straight.thin.map((d) => Math.abs(d))

      const newInput = []
      for (let i = 0; i < inputArray.length; i += 2) {
        newInput.push(Math.max(inputArray[i], inputArray[i + 1]))
      }
      inputArray = newInput

      inputArray = cutSilence(inputArray)
      inputArray = normalDistribute(inputArray)

      let normalizedEntries = inputArray
      const minAmplitude = 0.01
      normalizedEntries = normalizedEntries.map((entry) => {
        return entry < minAmplitude ? minAmplitude + entry : entry
      })
      normalizedEntries = fadeInOut(normalizedEntries, 0.021)
      normalizedEntries = normalizeArray(normalizedEntries)
      return visualizeAsPath(
        normalizedEntries,
        this.widthVisual,
        this.heightVisual
      )
    },
     isPrintMode: function() {
      return store.state.isPrintMode
    },
  },
  watch: {
    // save the previous path for the animation
    path(_, oldP) {
      this.previousPath = oldP
      const e = document.querySelector('animate')
      e.beginElement()
    },
  },
}
</script>